// @flow

import React from 'react'
import { useLocation } from 'react-router'
import { NavLink } from 'react-router-dom'

import OverviewIconGray from '../../Shared/Icons/icon-overview-grey.svg'
import OverviewIconSelected from '../../Shared/Icons/icon-overview-active.svg'
import NewsFeedIconGray from '../../Shared/Icons/icon-newsfeed-gray.svg'
import NewsFeedIconSelected from '../../Shared/Icons/icon-newsfeed-active.svg'
import AdminIconGray from '../../Shared/Icons/icon-admin-gray.svg'
import AdminIconSelected from '../../Shared/Icons/icon-admin-active.svg'
import IndividualIconGray from '../../Shared/Icons/icon-individual-gray.svg'
import IndividualIconSelected from '../../Shared/Icons/icon-individual-active.svg'
import OtherIconGray from '../../Shared/Icons/icon-other-gray.svg'
import OtherIconSelected from '../../Shared/Icons/icon-other-active.svg'
import NotificationSelected from '../../Shared/Icons/icon-notification-active.svg'
import NotificationGray from '../../Shared/Icons/icon-notification-gray.svg'
import './Nav.css'
import { useSelector } from 'react-redux'

function Nav () {
  const location = useLocation()
  const userAnalytics = useSelector(state => state.account.userAnalyticsEnabled)

  return (
    <div id='sidebarNav'>
      <strong> Activity </strong>
      <NavLink className={(navData) => (navData.isActive ? 'selected' : 'none')} to={'/dashboard'}><img alt='' src={location.pathname === '/dashboard' ? OverviewIconSelected : OverviewIconGray} />Dashboard</NavLink>
      <NavLink className={(navData) => (navData.isActive ? 'selected' : 'none')} to={'/contents'}><img alt='' src={location.pathname === '/contents' ? NewsFeedIconSelected : NewsFeedIconGray} />Content</NavLink>
      {userAnalytics ? <NavLink className={(navData) => (navData.isActive ? 'selected' : 'none')} to={'/admin'}><img alt='' src={location.pathname === '/admin' ? AdminIconSelected : AdminIconGray} />Administrator</NavLink> : null}
      {userAnalytics ? <NavLink className={(navData) => (navData.isActive ? 'selected' : 'none')} to={'/user-activity'}><img alt='' src={location.pathname === '/user-activity' ? IndividualIconSelected : IndividualIconGray} />User Activity</NavLink> : null}
      <NavLink className={(navData) => (navData.isActive ? 'selected' : 'none')} to={'/notifications'}><img alt='' src={location.pathname === '/notifications' ? NotificationSelected : NotificationGray} />Notifications</NavLink>
      <NavLink className={(navData) => (navData.isActive ? 'selected' : 'none')} to={'/other'}><img alt='' src={location.pathname === '/other' ? OtherIconSelected : OtherIconGray} />Other</NavLink>
    </div>
  )
}

export default Nav
